import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as MetricActions from "../actions/Actions.js";
import { HashLink as Link } from "react-router-hash-link";
import Helper from "../functions/Helper.js";
import DollarStepper from "../components/DollarStepper.js";
import { Helmet } from "react-helmet";
import Spinner from "react-bootstrap/Spinner";

import produce from "immer";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { useIsMount } from "../hooks/useIsMount.js";
import DealRow from "../components/DealRow.js";

const showShopsAmount = 3;

function reduceFilterObject(filterObject, defaultFilterObject, question_nr) {
  let tempFilterObject = { ...defaultFilterObject };
  for (let i = 0; i <= question_nr; i++) {
    tempFilterObject = { ...tempFilterObject, ...filterObject[i] };
  }
  Object.keys(tempFilterObject).forEach((key) => {
    if (tempFilterObject[key] === "") {
      delete tempFilterObject[key];
    }
  });
  return tempFilterObject;
}

const defaultFilterObject = {
  availability: "Available in Stores",
  review_amount: ">2",
  sortBy: "rating",
};

const Glyph = (props) => {
  let { checked } = props;
  return (
    <div
      style={{
        width: 60,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {checked === true ? (
        <i style={{ fontSize: 24 }} className="thg_glyph fa fa-check-circle " />
      ) : (
        <i style={{ fontSize: 20 }} className="thg_glyph far fa-circle" />
      )}
    </div>
  );
};

const SelectionImage = (props) => {
  let { image } = props;
  if (image !== 0) {
    return (
      <img
        style={{
          width: 120,
          height: 90,
          objectFit: "contain",
          padding: "10px 0px",
          marginRight: 20,
        }}
        src={image}
        alt=""
      />
    );
  } else {
    return null;
  }
};

function Quiz(props) {
  let location = useLocation();
  const navigate = useNavigate();
  let isMount = useIsMount();
  let question_nr = Number(
    Helper.getValueFromQueryString(location.search, "question") || -1
  );
  const memoController = useRef({ abort: () => { } });
  const quizContainer = useRef();
  const [loading, setLoading] = useState(false);
  const [showingMoreShops, setShowingMoreShops] = useState(false);

  function loadData(queryString, controller) {
    memoController.current.abort();
    memoController.current = controller;
    return fetch(__server__ + "/API/pub/filter" + queryString, {
      signal: controller.signal,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return { data: data, abortFunction: controller };
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    props.actions.visitedQuiz();

    if (!props.quiz.initiated) {
      let controller = new AbortController();
      loadData(
        "?" +
        queryString.stringify(
          { ...defaultFilterObject, required_data: "filters,stats" },
          []
        ),
        controller
      ).then((response) => {
        props.actions.initiateQuestions({
          all_shoe_count: response.data.stats.count,
          brands: response.data.filters.filter((x) => x.data === "brand")[0]
            .options,
        });
      });
      if (question_nr !== -1) {
        navigate("/shoe-reviews/quiz/", {
          replace: true,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (!isMount && question_nr !== -1) {
      let tempFilterObject = reduceFilterObject(
        props.quiz.filterObject,
        defaultFilterObject,
        question_nr
      );
      let controller = new AbortController();
      if (question_nr === 6) {
        let searchString = queryString.stringify(
          { ...tempFilterObject, required_data: "stats,data" },
          []
        );
        loadData("?" + searchString, controller).then((response) => {
          if (response) {
            Helper.fetchShoeData(response.data.data[0].url).then((x) => {
              Helper.gaEvent("quiz", "result", x.shoe_name);
              props.actions.shoeData(x);
              props.actions.quizOutputData(response.data.data);
              setTimeout(() => {
                setLoading(false);
              }, 1000);
            });
          }
        });
      } else {
        let searchString = queryString.stringify(
          { ...tempFilterObject, required_data: "stats" },
          []
        );
        loadData("?" + searchString, controller).then((response) => {
          if (response) {
            props.actions.quizNewCount(response.data.stats.count);
          }
        });
      }
    }
  }, [props.quiz.filterObject, question_nr]);

  const pickedPrice = (value) => {
    let newNumberInput = produce(props.quiz.numberInput, (draft) => {
      draft[question_nr] = value;
    });
    let { checkstatus } = apply_filter(props.quiz.checkstatus, newNumberInput);
    props.actions.changeAnswer({
      checkstatus: checkstatus,
      numberInput: newNumberInput,
    });
  };

  const generateList = (data, currentCheckstatus, question_nr) => {
    var selections = props.quiz.quizPages[question_nr].selections;
    if (data === "outdoor_text") {
      if (currentCheckstatus[0] == true) {
        return "";
      } else if (currentCheckstatus[1] == true) {
        return "good,fair";
      }
    } else if (data === "width_text") {
      if (currentCheckstatus[0] == true) {
        return "narrow,regular";
      } else if (currentCheckstatus[1] == true) {
        return "";
      } else if (currentCheckstatus[2] == true) {
        return "regular,wide";
      }
    } else {
      return selections
        .filter((x, index) => currentCheckstatus[index])
        .map((item) => item.filter)
        .join(",");
    }
  };

  const changeQuestion = (newQuestion) => {
    apply_filter(props.quiz.checkstatus, props.quiz.numberInput, newQuestion);
    navigate("/shoe-reviews/quiz/?question=" + newQuestion);
  };

  const next_question = (sign) => {
    if (window.outerWidth < 768) {
      quizContainer.current.scrollIntoView();
    }
    changeQuestion(question_nr + sign);

    if (props.quiz.quizPages[question_nr + sign].result === true) {
      setLoading(true);
    }
  };

  const isOneBoxUnticked = (obj) => {
    return Object.values(obj).includes(false);
  };

  const isOneBoxTicked = (obj) => {
    return Object.values(obj).includes(true);
  };

  const showNextQuestionButton = () => {
    if (props.quiz.current_shoe_count === 0) {
      return false;
    }
    let currentFilterType = props.quiz.quizPages[question_nr].filter.type;
    if (currentFilterType === "list" || currentFilterType === "position") {
      return isOneBoxTicked(props.quiz.checkstatus[question_nr]);
    }
    return true;
  };

  const apply_filter = (checkstatus, numberInput, question = question_nr) => {
    if (props.quiz.quizPages[question]?.filter) {
      let activeFilter = props.quiz.quizPages[question].filter;
      let filterObject = {};
      let currentCheckstatus = checkstatus[question];
      let newCheckStatus = checkstatus; //answering first question will trigger differe nt checkboxes for second question

      if (activeFilter.type === "number") {
        filterObject[activeFilter.data] = "<" + numberInput[question];
      } else if (activeFilter.type === "list") {
        if (
          isOneBoxUnticked(currentCheckstatus) &&
          isOneBoxTicked(currentCheckstatus)
        ) {
          filterObject[activeFilter.data] = generateList(
            activeFilter.data,
            currentCheckstatus,
            question
          );
          //check if filter excludes choices, if not-> don't add filter
        } else if (!isOneBoxUnticked(currentCheckstatus)) {
          filterObject[activeFilter.data] = "";
        }
      } else if (activeFilter.type === "position") {
        if (currentCheckstatus[0] == true) {
          //position=guard
          newCheckStatus = produce(checkstatus, (draft) => {
            draft[1] = { 0: true, 1: true, 2: false };
          });
          filterObject.style = "Low Top,Mid Top";
          filterObject.traction = ">8";
        } else if (currentCheckstatus[1] == true) {
          newCheckStatus = produce(checkstatus, (draft) => {
            draft[1] = { 0: true, 1: true, 2: true };
          });
          filterObject.traction = ">8";
          filterObject.cushion = ">8";
        } else if (currentCheckstatus[2] == true) {
          newCheckStatus = produce(checkstatus, (draft) => {
            draft[1] = { 0: false, 1: false, 2: true };
          });
          filterObject.style = "High Top";
          filterObject.support = ">8";
          filterObject.cushion = ">8";
        }
      }
      /*
      let newFilters=produce(props.quiz.quizfilters,draft=>{
        draft[question]=filter;
      });
      */
      props.actions.quizFilter({
        filters: filterObject,
        question_nr: question,
      });

      return {
        checkstatus: newCheckStatus,
      };
    }
  };

  const pickedAnswer = (col) => {
    let newCheckStatus = produce(props.quiz.checkstatus, (draft) => {
      if (props.quiz.quizPages[question_nr].multiple == true) {
        draft[question_nr][col] = !draft[question_nr][col];
      } else {
        if (props.quiz.checkstatus[question_nr][col] == false) {
          draft[question_nr] = [false, false, false];
          draft[question_nr][col] = true;
        } else {
          draft[question_nr][col] = !draft[question_nr][col];
        }
      }
    });

    let { checkstatus } = apply_filter(newCheckStatus, props.quiz.numberInput);
    props.actions.changeAnswer({ checkstatus });

    //props.actions.changeAnswer({checkstatus:newCheckStatus});

    //let {checkstatus}=apply_filter(newCheckStatus,props.quiz.numberInput);
    //props.actions.changeAnswer({checkstatus});
  };

  const output_selection = () => {
    let currentQuestion = props.quiz.quizPages[question_nr];
    if (currentQuestion.selections === "number") {
      return (
        <div style={{ marginBottom: 10 }}>
          <DollarStepper
            onChange={(value) => {
              pickedPrice(value);
            }}
            value={props.quiz.numberInput[question_nr]}
          />
        </div>
      );
    } else {
      return (
        <div
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            display: "flex",
          }}
        >
          {currentQuestion.selections.map((selection, index) => {
            let active = props.quiz.checkstatus[question_nr][index];
            return (
              <div
                key={question_nr + "-" + index}
                css={{
                  width: "100%",
                  cursor: "pointer",
                  flexDirection: "row",
                  display: "flex",
                  border: "1px solid #ccc",
                  alignItems: "center",
                  minHeight: 70,
                  marginBottom: 15,
                  backgroundColor: "white",
                  "@media (hover:hover)": {
                    "&:hover": {
                      backgroundColor: "var(--primary-color-600)",
                      color: "#fff",
                      borderColor: "var(--primary-color-600)",
                    },
                    ":hover .thg_glyph": {
                      color: "#fff",
                    },
                  },
                  ".thg_glyph": {
                    color: active ? "var(--primary-color-600)" : "#333333",
                  },
                  "@media (min-width:768px)": {
                    width: currentQuestion.multipleColumns && "48%",
                    marginRight: currentQuestion.multipleColumns && "2%",
                  },
                  "@media (min-width:991px)": {
                    width: currentQuestion.multipleColumns && "31%",
                    marginRight: currentQuestion.multipleColumns && "2%",
                  },
                }}
                onClick={() => {
                  pickedAnswer(index);
                }}
              >
                <Glyph checked={active} />
                <SelectionImage
                  image={props.quiz.quizPages[question_nr].images[index]}
                />
                <div style={{ fontSize: 18 }}>{selection.text}</div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  const output = () => {
    if (question_nr === -1) {
      return (
        <div>
          <h1 style={{ fontSize: 16 }}>Basketball Shoe Quiz</h1>
          <div style={{ maxWidth: 700, marginTop: 10 }}>
            <h2
              style={{
                fontSize: 30,
                fontWeight: 700,
                lineHeight: 1.4,
                marginBottom: 40,
              }}
            >
              What Basketball Shoes Should I Get?
            </h2>
            <div style={{ marginBottom: 30, fontSize: 18 }}>
              Just answer a few questions and we will search our database to
              find the best basketball shoes for you!
            </div>
            {props.quiz.initiated ? (
              <Button
                style={{ padding: "10px 20px" }}
                onClick={() => {
                  if (window.outerWidth < 768) {
                    quizContainer.current.scrollIntoView();
                  }
                  navigate("/shoe-reviews/quiz/?question=0");
                }}
              >
                Get started with the Quiz!
              </Button>
            ) : (
              <Spinner animation="border" variant="primary" />
            )}
          </div>
        </div>
      );
    } else if (!props.quiz.initiated) {
      return (
        <div style={{ marginTop: 50 }}>
          <Spinner animation="border" variant="primary" />
        </div>
      );
    } else {
      if (props.quiz.quizPages[question_nr].result === false) {
        return (
          <div style={{ width: "100%" }}>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              {question_nr !== 0 && (
                <div
                  title="go back to previous question"
                  style={{
                    fontSize: 25,
                    lineHeight: 1,
                    cursor: "pointer",
                    color: "#666666",
                    marginRight: 5,
                  }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <i className="text-primary fas fa-arrow-left"></i>
                </div>
              )}
              Question {question_nr + 1} of {props.quiz.quizPages.length - 1}
            </div>

            <div
              id="anchor"
              style={{
                fontSize: 30,
                fontWeight: 700,
                marginBottom: 10,
                lineHeight: 1.4,
              }}
            >
              {props.quiz.quizPages[question_nr].question}
            </div>
            <div style={{ marginBottom: 30, fontSize: 18 }}>
              {typeof props.quiz.quizPages[question_nr].description === "string"
                ? props.quiz.quizPages[question_nr].description
                : props.quiz.quizPages[question_nr].description[
                props.quiz.position
                ]}
            </div>
            {output_selection()}
            <div style={{ paddingTop: 20 }}>
              <Button
                key={question_nr}
                style={{ padding: "10px 30px" }}
                onClick={() => {
                  next_question(+1);
                }}
                disabled={!showNextQuestionButton()}
              >
                {question_nr === props.quiz.quizPages.length - 2
                  ? "Get Your Results"
                  : "Go to Next Question"}
              </Button>
            </div>

            <div style={{ paddingTop: 70, paddingBottom: 10 }}>
              {
                <div
                  style={{
                    color: props.quiz.current_shoe_count === 0 && "red",
                  }}
                >
                  So far,
                  <span style={{ fontWeight: "bold" }}>
                    {" " + props.quiz.current_shoe_count + " "} of{" "}
                    {" " + props.quiz.all_shoe_count + " "}
                    shoes&nbsp;
                  </span>
                  fit your chosen criteria.
                </div>
              }
              <Button
                className="mt-4"
                size="sm"
                variant="outline-secondary"
                onClick={() => {
                  changeQuestion(-1);
                  setTimeout(
                    () =>
                      window.outerWidth > 576 &&
                      document.getElementById("anchor").scrollIntoView(),
                    100
                  );
                }}
              >
                Restart Quiz
              </Button>
            </div>
          </div>
        );
      } else {
        let result_shoe = props.currentShoe ?? false;
        const colorways_by_shop = result_shoe.hasOwnProperty(
          "colorways_by_shop"
        )
          ? result_shoe.colorways_by_shop
          : Helper.sort_colorways_by_shop(result_shoe.colorways);
        const resells_by_shop = result_shoe.hasOwnProperty("resells_by_shop")
          ? result_shoe.resells_by_shop
          : Helper.sort_colorways_by_shop(result_shoe.resells);
        let colorways_and_resells_by_shop = [
          ...colorways_by_shop,
          ...resells_by_shop,
        ];

        return (
          <div
            id="quiz_container"
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
            }}
          >
            {loading && (
              <div style={{ display: !loading ? "none" : "block" }}>
                <div id="anchor">
                  Almost there! We are now searching for the best-rated
                  basketball shoes that fit all your criteria.
                </div>
                <div style={{ marginTop: 50 }}>
                  {loading && <Spinner animation="border" variant="primary" />}
                </div>
              </div>
            )}
            {!loading && result_shoe && (
              <React.Fragment>
                <div id="anchor" style={{ marginBottom: 20, display: "flex" }}>
                  Congratulations! We found the perfect basketball shoe for you:
                </div>

                <div style={{ fontSize: 40, fontWeight: 700 }}>
                  <Link
                    style={{ color: "var(--grey-800)" }}
                    rel="noopener noreferrer"
                    to={"/shoe-reviews/" + result_shoe.url + "/"}
                  >
                    {result_shoe.shoe_name}
                  </Link>
                </div>

                <Link
                  rel="noopener noreferrer"
                  to={"/shoe-reviews/" + result_shoe.url + "/"}
                >
                  <picture>
                    <source
                      type="image/webp"
                      srcSet={Helper.create_source_set(
                        result_shoe.pictures[1],
                        undefined,
                        "webp"
                      )}
                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                    />
                    <source
                      type="image/png"
                      srcSet={Helper.create_source_set(result_shoe.pictures[1])}
                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                    />

                    <img
                      width={result_shoe.pictures[1].width}
                      height={result_shoe.pictures[1].height}
                      loading={"lazy"}
                      style={{
                        maxWidth: 500,
                        width: "100%",
                        margin: "30px 0px",
                        transform:
                          result_shoe.pictures[1].mirror == "1" &&
                          "scaleX(-1)",
                      }}
                      src={Helper.add_options_img(
                        result_shoe.pictures[1].master,
                        585
                      )}
                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                      alt={result_shoe.shoe_name}
                      srcSet={Helper.create_source_set({
                        master: result_shoe.pictures[1].master,
                        thumbnails: "1",
                      })}
                    />
                    {/*<source srcset="img.jpg" type="image/jpeg">
                      <img src="img.jpg">*/}
                  </picture>
                </Link>

                <div style={{ marginBottom: 40, fontSize: 16, marginTop: 10 }}>
                  {result_shoe.short_summary}
                </div>

                <div style={{ maxWidth: 450 }}>
                  <div
                    style={{ fontWeight: 700, fontSize: 20, marginBottom: 5 }}
                  >
                    Price Comparison:
                  </div>
                  {!result_shoe.hasOwnProperty("colorways") ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 20,
                      }}
                    >
                      <Spinner animation="border" variant="primary" />
                      <span style={{ marginLeft: 10 }}>...loading shops</span>
                    </div>
                  ) : (
                    <>
                      <div style={{ marginBottom: 15, fontSize: 16 }}>
                        Available at {colorways_and_resells_by_shop.length}{" "}
                        {colorways_and_resells_by_shop.length === 1
                          ? "shop"
                          : "shops"}{" "}
                        | Official Retail Price: ${result_shoe.price}
                      </div>

                      {colorways_and_resells_by_shop
                        .slice(0, showingMoreShops ? 100 : showShopsAmount)
                        .map((colorways, index) => {
                          return (
                            <DealRow
                              key={index}
                              style={{ borderTopWidth: index === 0 ? 0 : 1 }}
                              trackingId={"quiz_price_comp"}
                              colorway={colorways.colorways[0]}
                            />
                          );
                        })}

                      {showingMoreShops &&
                        colorways_and_resells_by_shop.length >
                        showShopsAmount && (
                          <div
                            onClick={() => {
                              setShowingMoreShops(false);
                            }}
                            style={{
                              fontSize: 16,
                              cursor: "pointer",
                              color: "var(--primary-color-700)",
                              fontWeight: 600,
                              marginTop: 10,
                            }}
                          >
                            <i className="fas fa-arrow-up" /> See less shops
                          </div>
                        )}
                      {colorways_and_resells_by_shop.length === 0 && (
                        <div>No shops found</div>
                      )}

                      {!showingMoreShops &&
                        colorways_and_resells_by_shop.length >
                        showShopsAmount && (
                          <div
                            onClick={() => {
                              setShowingMoreShops(true);
                            }}
                            style={{
                              fontSize: 16,
                              cursor: "pointer",
                              color: "var(--grey-800)",
                              fontWeight: "bold",
                              marginTop: 10,
                            }}
                          >
                            <i className="fas fa-arrow-down" /> See all{" "}
                            {colorways_and_resells_by_shop.length} shops
                          </div>
                        )}
                    </>
                  )}
                </div>

                {props.quiz.quiz_output_data.length > 1 && (
                  <div style={{ paddingTop: 20, paddingBottom: 30 }}>
                    <div style={{ paddingTop: 20 }}>
                      <Link
                        to={
                          "/shoe-reviews/?" +
                          queryString.stringify(
                            reduceFilterObject(
                              props.quiz.filterObject,
                              defaultFilterObject,
                              question_nr
                            )
                          )
                        }
                      >
                        <Button
                          key={question_nr}
                          style={{ padding: "10px 30px" }}
                        >
                          See all {" " + props.quiz.current_shoe_count + " "}{" "}
                          Shoes that fit you!
                        </Button>
                      </Link>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        );
      }
    }
  };

  return (
    <div>
      <Helmet>
        <meta
          property="og:title"
          content="Basketball Shoe Quiz - Answer 6 Questions to Find Your Perfect Shoes"
        />
        <meta property="og:image:width" content="1020" />
        <meta property="og:image:height" content="510" />
        <meta
          property="og:image"
          content="https://www.thehoopsgeek.com/wp-content/uploads/2018/07/10_best_basketball_shoes-2.png"
        />
        <meta
          name="description"
          content="Find basketball shoes that fit your playing style, feet, and budget by answering 6 simple questions."
        />
        <title>
          Basketball Shoe Quiz - Answer 6 Questions to Find Your Perfect Shoes
        </title>
      </Helmet>
      <div
        ref={quizContainer}
        css={{
          display: "flex",
          minHeight: "100vh",
          marginBottom: 40,
          paddingTop: 20,
          "@media (min-width: 768px)": {
            backgroundColor: "#f8f8f8",
            padding: "40px 40px 10px 40px",
            minHeight: 600,
          },
        }}
      >
        {output()}
      </div>
      <div className="adthrive-ad" />
      <div style={{ marginBottom: 200 }}></div>

    </div>
  );
}

export default connect(
  (state) => ({ quiz: state.quiz, currentShoe: state.data.currentShoe }),
  (dispatch) => ({
    actions: bindActionCreators(MetricActions, dispatch),
  })
)(Quiz);
